import { BestPlayers, GoalkeeperRatings } from "@/models";
import { ActionTree } from "vuex";
import { MatchMutationTypes, MatchState } from ".";
import matchApi from "../../api/match.api";
import i18n from "../../i18n";
import { EditMatch } from "./../../models/match.model";
import { ToastMessage } from "./../../models/toast-message.model";
import { RootActionTypes, RootState } from "./../index";
import { RootMutationTypes } from "./../root-mutations";
import * as Sentry from "@/utils/logger.util";

export const MatchActionTypes = {
  FetchMatch: "FETCH_MATCH",
  PutMatch: "PUT_MATCH",
  PutReferee: "PUT_REFEREE",
  PutBestPlayers: "PUT_BEST_PLAYERS",
  PutGoalkeeperRatings: "PUT_GOALKEEPER_RATINGS"
};

export const actions: ActionTree<MatchState, RootState> = {
  async [MatchActionTypes.FetchMatch]({ commit, dispatch }, matchId: number) {
    try {
      const response = await matchApi.getMatch(matchId);
      const match = response.data.data;

      commit(MatchMutationTypes.SetMatch, match);
      return match;
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  },

  async [MatchActionTypes.PutReferee]({ commit, dispatch }, payload: { matchId: number; editMatch: EditMatch }) {
    try {
      const {
        data: {
          data: { referees = "", referee_comment = [] }
        }
      } = await matchApi.putMatch(payload.matchId, payload.editMatch);
      commit(MatchMutationTypes.SetMatch, { referees, referee_comment });
      commit(
        RootMutationTypes.SetToastMessages,
        {
          title: i18n.tc("alert.title.success"),
          variant: "success",
          content: i18n.t("edit_match.update_success")
        } as ToastMessage,
        { root: true }
      );
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  },
  async [MatchActionTypes.PutMatch]({ commit, dispatch }, payload: { matchId: number; editMatch: EditMatch }) {
    try {
      await matchApi.putMatch(payload.matchId, payload.editMatch);

      commit(
        RootMutationTypes.SetToastMessages,
        {
          title: i18n.tc("alert.title.success"),
          variant: "success",
          content: i18n.t("edit_match.update_success")
        } as ToastMessage,
        { root: true }
      );
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  },
  async [MatchActionTypes.PutBestPlayers]({ commit, dispatch }, payload: { matchId: number; bestPlayers: BestPlayers }) {
    try {
      await matchApi.putBestPlayers(payload.matchId, payload.bestPlayers);
      commit(
        RootMutationTypes.SetToastMessages,
        {
          title: i18n.tc("alert.title.success"),
          variant: "success",
          content: i18n.t("edit_match.best_player_success")
        } as ToastMessage,
        { root: true }
      );
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  },

  async [MatchActionTypes.PutGoalkeeperRatings]({ commit, dispatch }, payload: { matchId: number; goalkeeperRatings: GoalkeeperRatings }) {
    try {
      await matchApi.putGoalkeeperRating(payload.matchId, payload.goalkeeperRatings);
      commit(
        RootMutationTypes.SetToastMessages,
        {
          title: i18n.tc("alert.title.success"),
          variant: "success",
          content: i18n.t("edit_match.goalkeeper_rating_success")
        } as ToastMessage,
        { root: true }
      );
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  }
};
